import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IComponentController } from 'angular';

interface IPageCp2019 extends IComponentController {
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    formulairerpc: IFormulaire
}
/* @ngInject */
export default function Cp2018Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass) {
    const vm: IPageCp2019 = this;
    vm.$onInit = $onInit;

    function $onInit() {
        vm.monoOccurrenceOptions = {
            fonctions: {
                boutonDupliquer: false,
                supprime: false,
                exportation: false,
                nouveau: false,
                suiviModification: false,
                boutonEnregistrerHaut: false
            }
        }

        vm.formulairerpc = new Formulaire('LBL_BLC_RPC', [
            new FormulaireItem('villefournisseur', { largeur: 33.33, readonly: true }),
            new FormulaireItem('paysfournisseur', { largeur: 33.33, readonly: true }),
            new FormulaireItem('datefacture', { largeur: 33.33, readonly: true }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('numfacturefournisseur', { largeur: 33.33, readonly: true }),
            new FormulaireItem('descriptionfacture', { largeur: 33.33, readonly: true }),
            new FormulaireItem('codeetablissement', { largeur: 33.33, readonly: true }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('provincefournisseur', { largeur: 33.33, readonly: true }),
            new FormulaireItem('ruefournisseur', { largeur: 33.33, readonly: true }),
            new FormulaireItem('montantfacture', { largeur: 33.33, readonly: true }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('adressefournisseur', { largeur: 33.33, readonly: true }),
            new FormulaireItem('telephonefournisseur', { largeur: 33.33, readonly: true }),
            new FormulaireItem('zipfournisseur', { largeur: 33.33, readonly: true }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('boncommande', { largeur: 33.33, readonly: true }),
            new FormulaireItem('idtransaction', { largeur: 33.33, readonly: true }),
            new FormulaireItem('piecejointes', { largeur: 33.33, readonly: true, isChampDescriptionHtml: { afficherLibelle: true, remplacerBackground: true } }),
            new FormulaireItem('instructionsfin', { largeur: 80, readonly: true })
        ]);

    }
}
